<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">
      <inertia-link class="text-blue-400 hover:text-blue-600" :href="route('category')">Categorias</inertia-link>
      <span class="text-blue-400 font-medium">/</span> Crear
    </h1>
    <div class="bg-white rounded-md shadow overflow-hidden max-w-3xl">
      <form @submit.prevent="store">
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
            <text-input v-model="form.name" :error="form.errors.name" class="pr-6 pb-8 w-full lg:w-1/2" label="Nombre" />
            <text-input v-model="form.en_name" :error="form.errors.en_name" class="pr-6 pb-8 w-full lg:w-1/2" label="Nombre en ingles" />
            <text-area-input v-model="form.description" :error="form.errors.description" class="pr-6 pb-8 w-full lg:w-1/2" label="Descripcion" />
            <text-area-input v-model="form.en_description" :error="form.errors.en_description" class="pr-6 pb-8 w-full lg:w-1/2" label="Descripcion en ingles" />
        </div>
        <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex justify-end items-center">
          <loading-button :loading="form.processing" class="btn-indigo" type="submit">Crear Categoria</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import TextAreaInput from '@/Shared/TextAreaInput'


export default {
  metaInfo: { title: 'Crear categoria' },
  components: {
    LoadingButton,
    SelectInput,
    TextInput,
    TextAreaInput
  },
  layout: Layout,
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        name: null,
        description: null,
        en_description: null,
        en_name: null,
      }),
    }
  },
  methods: {
    store() {
      this.form.post(this.route('category.store'))
    },
  },
}
</script>
